import { usePunditUserContext } from "@/react/contexts";

export const useIsReusableBlocksEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.reusable_blocks_enabled);
};
